import { AlertInfo } from "@/store/alert";
import { LocalDiscount, TempDiscount } from "./type";
import { CustomerGroupResponse } from "@/models/response/customerGroup";
import { discountGroup, SmsTemplate } from "@/services/discount/type";

export const persistTempDiscount = (
  payload: TempDiscount,
  selectedGroup: CustomerGroupResponse | discountGroup,
  selectedTemplate: SmsTemplate,
  addAlert: (command: AlertInfo) => void
) => {
  const storeDiscounts = localStorage.getItem("discounts");

  if (storeDiscounts) {
    const discounts: Array<LocalDiscount> = JSON.parse(storeDiscounts);

    let exist = discounts?.find(
      (x) =>
        x?.discount?.id === payload.id ||
        x?.discount?.customerGroupId === payload.customerGroupId ||
        x?.discount?.discountGroupId === payload.discountGroupId
    );

    if (!exist) {
      discounts?.push({
        discount: payload,
        group: selectedGroup,
        selectedTemplate: selectedTemplate,
      });
      addAlert({
        id: payload?.id || "",
        type: "discount",
        text: selectedTemplate?.text || "",
        title: "ارسال پیامک خود را نهایی کنید",
        creationDateTime: new Date(),
      });
      localStorage.setItem("discounts", JSON.stringify(discounts));
    } else {
      const newDiscounts = discounts?.filter(
        (x) => exist?.discount?.id !== x?.discount?.id
      );
      newDiscounts.push({
        discount: payload,
        group: selectedGroup,
        selectedTemplate,
      });

      localStorage.setItem("discounts", JSON.stringify(newDiscounts));
    }
  } else {
    const discounts: Array<LocalDiscount> = [];
    discounts?.push({
      discount: payload,
      group: selectedGroup,
      selectedTemplate,
    });
    addAlert({
      id: payload?.id || "",
      type: "discount",
      text: selectedTemplate?.text || "",
      title: "ایجاد تخفیف",
      creationDateTime: new Date(),
    });
    localStorage.setItem("discounts", JSON.stringify(discounts));
  }
};
